import { httpClient } from '@/services/http/httpClient'

export async function deleteComment(commentId: string) {
  return await httpClient.delete('/users/videos/comments', {
    data: { commentId },
  })
}
